export const defaultPageTitle = 'Service NSW - Driver Knowledge Test';
export const pageHeadingLabel = 'Enrol in DKT online';
export const checkEligibilityHeadingTitle = 'Check eligibility';
export const genericErrorTitle = 'Sorry, you cannot proceed online';
export const loadingOverlayText =
  'Processing, please wait. Do not refresh or navigate away.';
